// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__hRkVT","label":"Labeled_label__InIJv","divider":"Labeled_divider__2bQW-"};